import { render } from "./monitoring.coreos.com.route.vue?vue&type=template&id=1b6a2152"
import script from "./monitoring.coreos.com.route.vue?vue&type=script&lang=js"
export * from "./monitoring.coreos.com.route.vue?vue&type=script&lang=js"

import "./monitoring.coreos.com.route.vue?vue&type=style&index=0&id=1b6a2152&lang=scss"

import exportComponent from "../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__